import * as angular from "angular";
import {IController} from "angular";
import {LocationType} from "../../../commons/types/location.type";
import * as _ from "lodash";
import {AccountModel} from "../../../account/angular/models/account.model";
import {SiteContextService} from "../../../commons/services/site-context.service";

export class ServiceTaskSpecFormComponent implements IController {

  taskSpec: any;
  onChange: Function;

  public locationTypes: typeof LocationType = LocationType;
  public siteInfo: any;

  constructor(private siteContextService: SiteContextService) {

  }

  $onInit() {
    this.siteInfo = this.siteContextService.getSiteInfo();
  }

  onLocationTypeChange(locationType: LocationType) {

    if (!this.taskSpec.locationDetails) {
      this.taskSpec.locationDetails = {}
    }

    if (!this.taskSpec.contact) {
      this.taskSpec.contact = {}
    }

    _.unset(this.taskSpec, 'locationDetails.id');

    this.taskSpec.locationDetails.locationType = locationType;

    _.unset(this.taskSpec, 'customerId');

    this.onChange({taskSpec: this.taskSpec});

  }

  onAccountLocationSelect(account: AccountModel) {
    this.taskSpec.locationDetails.id = _.get(account, 'id');
    this.taskSpec.contact.businessName = _.get(account, 'name');
    this.taskSpec.contact.name = _.get(account, 'name');
    this.taskSpec.contact.phoneNo = _.get(account, 'phoneNumber');
    this.taskSpec.contact.additionalPhoneNo = _.get(account, 'additionalPhoneNo');

    this._changeAddress(_.get(account, 'address'));
    this.onChange({taskSpec: this.taskSpec});

  }

  onDepotLocationSelect(depot) {
    this.taskSpec.locationDetails.id = _.get(depot, 'id');
    this.taskSpec.contact.businessName = _.get(depot, 'name');
    this.taskSpec.contact.name = _.get(depot, 'contactName');
    this.taskSpec.contact.phoneNo = _.get(depot, 'phoneNumber')
    this.taskSpec.contact.additionalPhoneNo = _.get(depot, 'additionalPhoneNo');

    this._changeAddress(_.get(depot, 'address'));
    this.onChange({taskSpec: this.taskSpec});

  }

  onCustomerLocationSelect(customer) {
    this.taskSpec.locationDetails.id = _.get(customer, 'id');
    this.taskSpec.customerId = _.get(customer, 'id');
    this.taskSpec.contact.name = this._getCustomerName(customer);
    this.taskSpec.contact.businessName = _.get(customer, 'businessName');
    this.taskSpec.contact.phoneNo = _.get(customer, 'phone');
    this.taskSpec.contact.additionalPhoneNo = _.get(customer, 'additionalPhone');
    this.taskSpec.contact.email = _.get(customer, 'email');

    const address = _.find(customer.addresses, (a) => {
      return a.id === customer.defaultAddressId;
    })
    if (address) {
      this._changeAddress(address);
    }
    this.onChange({taskSpec: this.taskSpec});
  }

  onPhoneChange(phone) {
    this.taskSpec.contact.phoneNo = phone;
    this.onChange({taskSpec: this.taskSpec});
  }

  onAdditionalPhoneChange(additionalPhoneNo) {
    this.taskSpec.contact.additionalPhoneNo = additionalPhoneNo;
    this.onChange({taskSpec: this.taskSpec});
  }

  onAddressChange(address) {
    this.taskSpec.address = address;
    this.onChange({taskSpec: this.taskSpec});
  }

  private _changeAddress(address) {
    this.taskSpec.address = address;
  }

  private _getCustomerName(customer) {
    if (!customer) {
      return undefined;
    }
    return _.get(customer, 'firstName', '') + ' ' + _.get(customer, 'lastName', '');
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceTaskSpecForm', {
    bindings: {
      taskSpec: '<',
      onChange: '&'
    },
    template: require('./service-task-spec-form.html').default,
    controller: ServiceTaskSpecFormComponent
  });
